// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2tlB8","filesListContainer":"PosDisputesFiles_filesListContainer__3eLD5","filesButton":"PosDisputesFiles_filesButton__2NH3b"};